import FontIcon from './FontIcon';
export default FontIcon;



// WEBPACK FOOTER //
// ./src/js/FontIcons/index.js